// Minimal shim to support Bootstrap 4 style data-bs-dismiss="modal" buttons on Bootstrap 5
// Works by listening for clicks on elements with [data-bs-dismiss="modal"] and closing the nearest .modal
(function () {
  function findClosestModal(element) {
    while (element && element !== document.body) {
      if (element.classList && element.classList.contains('modal')) {
        return element;
      }
      element = element.parentElement;
    }
    return null;
  }

  function upgradeAttributes(root) {
    if (!root) return;
    var nodes = root.querySelectorAll('[data-bs-dismiss="modal"]');
    nodes.forEach(function (el) {
      if (!el.hasAttribute('data-bs-dismiss')) {
        el.setAttribute('data-bs-dismiss', 'modal');
      }
    });
  }

  // Initial pass to convert existing markup
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { upgradeAttributes(document.body); });
  } else {
    upgradeAttributes(document.body);
  }

  // Observe DOM mutations to convert dynamically added nodes
  try {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'childList') {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              upgradeAttributes(node);
            }
          });
        }
        if (m.type === 'attributes' && m.attributeName === 'data-dismiss') {
          var el = m.target;
          if (el.getAttribute('data-dismiss') === 'modal' && !el.hasAttribute('data-bs-dismiss')) {
            el.setAttribute('data-bs-dismiss', 'modal');
          }
        }
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-dismiss'] });
  } catch (e) { /* ignore */ }

  document.addEventListener('click', function (event) {
    var target = event.target;
    // support clicks on child icons/spans insi
    // de the button
    while (target && target !== document.body && !target.getAttribute('data-dismiss')) {
      target = target.parentElement;
    }
    if (!target || target === document.body) {
      return;
    }
    if (target.getAttribute('data-dismiss') === 'modal') {
      event.preventDefault();
      var modalEl = findClosestModal(target);
      if (!modalEl) return;
      try {
        if (window.bootstrap && window.bootstrap.Modal) {
          var instance = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
          instance.hide();
        } else if (typeof $ !== 'undefined' && typeof $(modalEl).modal === 'function') {
          // Fallback in case Bootstrap 4 JS is present
          $(modalEl).modal('hide');
        } else {
          // Last resort: remove .show and hide element
          modalEl.classList.remove('show');
          modalEl.style.display = 'none';
          document.body.classList.remove('modal-open');
          var backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(function (bd) { bd.parentNode && bd.parentNode.removeChild(bd); });
        }
      } catch (e) {
        // no-op
      }
    }
  }, true);
})();


